/* YouTube-Verweise.
 *
 * Reine Funktionen — kein DOM, kein Netzwerk.
 */

/**
 * Video-Kennung aus einer YouTube-Adresse ziehen.
 * Deckt die Schreibweisen ab, die im Bestand vorkommen:
 *   youtube.com/watch?v=ID · youtu.be/ID · /embed/ID · /shorts/ID · /live/ID · nur die 11-stellige ID
 * Liefert null, wenn nichts Passendes gefunden wird.
 */
export function extractYouTubeId(url) {
  if (!url) return null;
  /* nur die Kennung (genau 11 Zeichen, nichts sonst) */
  if (/^[A-Za-z0-9_-]{11}$/.test(String(url).trim())) return String(url).trim();
  const patterns = [
    /[?&]v=([A-Za-z0-9_-]{11})/,
    /youtu\.be\/([A-Za-z0-9_-]{11})/,
    /\/embed\/([A-Za-z0-9_-]{11})/,
    /\/shorts\/([A-Za-z0-9_-]{11})/,
    /\/live\/([A-Za-z0-9_-]{11})/,
  ];
  for (const re of patterns) {
    const m = String(url).match(re);
    if (m) return m[1];
  }
  return null;
}

/**
 * Die normale YouTube-Adresse zum Öffnen (Knopf "Play video"): https://www.youtube.com/watch?v=ID.
 * Ein echter Link auf diese Adresse lässt das Handy die YouTube-App öffnen, wenn sie installiert ist, sonst den Browser —
 * ohne eigenes App-Schema und ohne Skript. Ein Startzeitpunkt (?t=90, &t=1m30s, ?start=90) bleibt erhalten.
 * Liefert null, wenn die Eingabe keine YouTube-Adresse oder -Kennung ist.
 */
export function youTubeWatchUrl(input) {
  const id = extractYouTubeId(input);
  if (!id) return null;
  /* Eine Adresse muss von YouTube sein (nicht irgendeine Seite mit ?v=…); die bloße Kennung ist erlaubt */
  const text = String(input).trim();
  const bare = /^[A-Za-z0-9_-]{11}$/.test(text);
  if (!bare && !/^(?:https?:\/\/)?(?:[\w-]+\.)?(?:youtube\.com|youtu\.be|youtube-nocookie\.com)(?:[/?#]|$)/i.test(text)) return null;
  const m =/[?&#](?:t|start)=(\d+(?:h\d*m?\d*s?|m\d*s?|s)?)(?=$|[&#])/i.exec(String(input));
  return `https://www.youtube.com/watch?v=${id}${m ? `&t=${m[1]}` : ''}`;
}

/**
 * Adresse für einen Link nur dann, wenn sie mit http:// oder https:// beginnt und keinen Leerraum enthält —
 * alles andere (javascript:, data:, Freitext) wird kein Link. Sonst ''.
 */
export function safeHttpUrl(input) {
  const s = String(input == null ? '' : input).trim();
  return /^https?:\/\/[^\s]+$/i.test(s) ? s : '';
}

/* Nicht mehr benutzt (seit F4 öffnet der Knopf YouTube, es gibt keinen eingebetteten Player mehr). */
export function youTubeEmbed(id) {
  return id ? `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0` : null;
}
